import { Select } from "antd";
import { SelectComPesquisa } from "../../../../../SelectComPesquisa";
import { useListar } from "../../../../../../Services/Financeiro/Titulo/Origem/OrigemTipoService";

interface IOrigemTipoSelectProps extends Omit<React.ComponentProps<typeof Select>, | "showSearch" | "optionFilterProp" | "filterOption"> {
}
export default function OrigemTipoSelect({
    ...props
}:IOrigemTipoSelectProps) {   
    const {
        data,
        isLoading
    } = useListar({
        //ativo : true
    });

    return <SelectComPesquisa
        {...props}
        placeholder={"Selecione"}
        allowClear
        loading={isLoading}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}